module.exports = __webpack_public_path__ + "static/media/giftCards.633eebb0.png";